export const SLIDER_OPTIONS = {
    animation: {
        type: 'monoSlider'
    },
    controls: {
        arrows: { enabled: true },
        bullets: { enabled: false },
        buttons: { enabled: false }
    }
};
